import { motion } from "framer-motion";

export default function BrandStory() {
  return (
    <section id="story" data-testid="brand-story" className="bg-background border-t border-white/10">
      <div className="grid lg:grid-cols-5">
        <div className="relative min-h-[55vh] lg:col-span-3">
          <img
            src="https://images.pexels.com/photos/37143616/pexels-photo-37143616.jpeg"
            alt="Night stadium skyline"
            className="absolute inset-0 w-full h-full object-cover opacity-70"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/30 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-background lg:to-background/60" />
          <p className="absolute bottom-8 left-8 font-anton text-[14vw] lg:text-[7vw] leading-none uppercase text-white/10 select-none">
            Blend
          </p>
        </div>
        <div className="flex flex-col justify-center px-6 md:px-12 lg:px-14 py-20 lg:col-span-2">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-xs uppercase tracking-[0.35em] font-bold text-primary mb-6">Our Story</p>
            <h2 className="font-anton text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.9] text-white">
              Born from the game.<br />Built for<br /><span className="text-primary">the culture.</span>
            </h2>
            <p className="text-white/55 mt-8 max-w-md leading-relaxed">
              Jersey Blend started with one obsession — turning the jerseys of legends into everyday streetwear you'll
              actually live in. Every hoodie and tee is printed on-demand with premium blanks, so nothing is wasted and
              every piece is made for you.
            </p>
            <p className="text-white/55 mt-4 max-w-md leading-relaxed">
              We rep the teams and nations that made history — the beautiful game, the gridiron, and the hardwood.
              From World Cup soccer sides to NFL and NBA cities, every drop celebrates the fans who live for game day.
            </p>
            <div className="grid grid-cols-3 gap-6 mt-12 max-w-md">
              {[
                ["100%", "Print-on-demand"],
                ["48", "Soccer nations"],
                ["3", "Leagues repped"],
              ].map(([n, l]) => (
                <div key={l} className="border-l-2 border-primary pl-3">
                  <p className="font-anton text-3xl text-white">{n}</p>
                  <p className="text-[11px] text-white/50 uppercase tracking-[0.15em] mt-1">{l}</p>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
